import { metaNameInScript } from "@repo/core/source-scan/meta-name-in-script";

/** The label's `meta.name`, read the way the parser anchors, bounds and picks it. */
export function workflowScriptName(script: string): string | undefined {
  return metaNameInScript(script);
}
